import { useQuery } from 'react-query'
import {
  apiGetFaults,
  apiGetFaultTypes,
  apiGetFaultByProblemLogId,
} from '../api/faults'

export const FAULT_REPORT_QUERY_KEY = 'faults'

export const useFaults = ({
  makeModelIds,
  stationIds,
  start_at,
  end_at,
  station_alerts,
  plants,
  zones,
  teams,
  department,
  testZones,
  refreshInterval,
  reason,
  vinStatus,
  includeRepairNotes,
}) => {
  const queryConfig = {
    refetchOnWindowFocus: false,
    enabled: !!start_at && !!end_at,
  }
  if (refreshInterval) {
    queryConfig.refetchInterval = refreshInterval
  }
  const {
    status,
    data: faults,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useQuery(
    [
      FAULT_REPORT_QUERY_KEY,
      makeModelIds,
      stationIds,
      start_at,
      end_at,
      station_alerts,
      plants,
      zones,
      teams,
      department,
      testZones,
      reason,
      vinStatus,
      includeRepairNotes,
    ],
    async () => {
      const result = await apiGetFaults({
        makeModelIds,
        stationIds,
        start_at,
        end_at,
        station_alerts,
        plants,
        zones,
        teams,
        department,
        testZones,
        reason,
        vinStatus,
        includeRepairNotes,
      })

      return result.data
    },
    queryConfig,
  )
  return {
    status,
    faults,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
    refetch,
  }
}

export const useFaultTypes = () => {
  const {
    status,
    data: faultTypes,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    ['fault_types'],
    async () => {
      const result = await apiGetFaultTypes()
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: true,
    },
  )
  return {
    status,
    faultTypes,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

// Fetches a single fault by its problem_log_id -- used to resolve a fault
// from a route param when it wasn't handed down via router location.state
// (e.g. after a page refresh or a shared link).
export const useFaultByProblemLogId = (problemLogId) => {
  const {
    status,
    data: fault,
    error,
    isLoading,
  } = useQuery(
    ['fault-by-problem-log-id', problemLogId],
    async () => {
      return await apiGetFaultByProblemLogId(problemLogId)
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!problemLogId,
    },
  )
  return { status, fault, error, isLoading }
}
